function BulkAddAdmissionGroupsModalCtrl($scope, $uibModalInstance, admissionGroupType, date, venue, organizationId, eventId, modalHeader, inventory, bulkUploadType) {
  _initScope();

  function _initScope() {
    $scope.admissionGroupType = admissionGroupType || 'TABLE';
    $scope.date = date;
    $scope.venue = venue;
    $scope.organizationId = organizationId;
    $scope.modalHeader = modalHeader;
    $scope.eventId = eventId;
    $scope.inventory = inventory;
    $scope.bulkUploadType = bulkUploadType;

    $scope.onAdded = function (result) {
      $uibModalInstance.close(result);
    };

    $scope.close = function () {
      $uibModalInstance.close(false);
    };
  }
}

BulkAddAdmissionGroupsModalCtrl.$inject = [
  '$scope',
  '$uibModalInstance',
  'admissionGroupType',
  'date',
  'venue',
  'organizationId',
  'eventId',
  'modalHeader',
  'inventory',
  'bulkUploadType'
];

export default BulkAddAdmissionGroupsModalCtrl;



// WEBPACK FOOTER //
// ./src/modals/bulkAddAdmissionGroups/controller.js